export const environment = {
    production: false,
    apiUrl: '/api',
    supportMail: 'gms@geislinger.com',
    navisClientId: 'Geislinger.Analytics-BrowserApp.nonprod',
    termsAndConditions: 'Geislinger_Terms_and_conditions_GS442B.pdf',
    gmsRequestManual: 'GMS_request_manual_v1.pdf'
};
